module.exports = __webpack_public_path__ + "static/media/picasso-2.ad55c291.jpeg";